import { render, staticRenderFns } from "./DepositGroup.vue?vue&type=template&id=3c0c341a&scoped=true&"
import script from "./DepositGroup.vue?vue&type=script&lang=js&"
export * from "./DepositGroup.vue?vue&type=script&lang=js&"
import style0 from "./DepositGroup.vue?vue&type=style&index=0&id=3c0c341a&scoped=true&lang=css&"
import style1 from "./DepositGroup.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0c341a",
  null
  
)

export default component.exports